import { render, staticRenderFns } from "./WordListConfig.vue?vue&type=template&id=1f1f28fe"
import script from "./WordListConfig.vue?vue&type=script&lang=js"
export * from "./WordListConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f1f28fe')) {
      api.createRecord('1f1f28fe', component.options)
    } else {
      api.reload('1f1f28fe', component.options)
    }
    module.hot.accept("./WordListConfig.vue?vue&type=template&id=1f1f28fe", function () {
      api.rerender('1f1f28fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/Edit/QuestionConfig/WordListConfig.vue"
export default component.exports